<script lang="ts">
  import FeatherIcon from "svelte-feather-icon";
  import { Button, Form, FormGroup, Input} from "sveltestrap";
  import { AddNew, Upload, href } from "../../../utils/Constant/Constant";
</script>
<div class="media">
    <Form class="form-inline" action="#" method="get">
        <FormGroup class="mb-0 d-flex">
            <i class="fa fa-search" />
            <Input
                class="form-control-plaintext"
                type="text"
                placeholder="Search..."
            />
        </FormGroup>
    </Form>
    <div class="media-body text-end">
        <Form
            class="d-inline-flex"
            action="#"
            method="POST"
            enctype="multipart/form-data"
            name="myForm"
        >
            <Button color="primary" href={href}>
                <FeatherIcon icon="plus-square" />{AddNew}
            </Button>
            <div style="height: 0px;width: 0px; overflow:hidden;" >
                <Input
                    id="upfile"
                    type="file"
                />
            </div>
        </Form>
        <Button outline color="primary" class="ms-2">
            <FeatherIcon icon="upload" />{Upload}
        </Button>
    </div>
</div>